// extracted by mini-css-extract-plugin
export default {"header":"HomeComponentsLayout_header__IalAg","title":"HomeComponentsLayout_title__0WmF9","link":"HomeComponentsLayout_link__uYS72","wrapper":"HomeComponentsLayout_wrapper__rXjOz"};